import { createContext, useContext, useRef, ReactNode } from "react";

import { useScreenDetector } from "hooks/useScreenDetector";
import type { ScreenDetectorResult } from "hooks/useScreenDetector";

const ScreenContext = createContext<ScreenDetectorResult | undefined>(undefined);

export const ScreenProvider = ({ children }: { children: ReactNode }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const screenInfo = useScreenDetector(containerRef);

  return (
    <ScreenContext.Provider value={screenInfo}>
      <div ref={containerRef} style={{ containerType: "inline-size" }}>
        {children}
      </div>
    </ScreenContext.Provider>
  );
};

export const useScreenContext = (): ScreenDetectorResult => {
  const context = useContext(ScreenContext);

  if (!context) {
    throw new Error("useScreenContext must be used within a ScreenProvider");
  }
  return context;
};
